var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotePurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#513764;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2153",
    transform: "translate(-720 -610)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2181",
    className: "st0",
    d: "M750,610h40c16.6,0,30,13.4,30,30v70l0,0h-70c-16.6,0-30-13.4-30-30v-40 C720,623.4,733.4,610,750,610z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M740,658.2v-16.9c0-3,2.4-5.4,5.4-5.4h16.9c1.9,0,3.8,0.8,5.1,2.1l19,19c2.8,2.8,2.8,7.4,0,10.3l-15.1,15.1 c-2.8,2.8-7.4,2.8-10.3,0l-19-19C740.8,662,740,660.2,740,658.2z M756.3,648.6c0-2-1.6-3.6-3.6-3.6s-3.6,1.6-3.6,3.6 s1.6,3.6,3.6,3.6S756.3,650.6,756.3,648.6z M779.1,636.7l14.5,14.6c5.9,6,5.9,15.7,0,21.7l-12.7,12.8c-1.1,1.1-2.8,1.1-3.8,0 c-1.1-1.1-1.1-2.8,0-3.8l12.7-12.8c3.8-3.9,3.8-10.1,0-14l-14.5-14.6c-1.1-1.1-1-2.8,0-3.8C776.3,635.6,778,635.6,779.1,636.7 L779.1,636.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotePurple);
export default __webpack_public_path__ + "static/media/Quote_Purple.c6164e1e361c8d6189b0ef7c62df7543.svg";
export { ForwardRef as ReactComponent };